@if (showCheckboxes) {
    <div class="agpr-formField" role="group" [attr.aria-labelledby]="field.headingId">
        <div
            *ngIf="field.label"
            class="agpr-formField-label agpr-checkboxesContainer-heading"
        >
            {{ field.label | localize }}
        </div>
        <div
            role="list"
            [ngClass]="{ 'agpr-checkboxesContainer-twoColumnWrapper': twoColumns }"
            [attr.aria-label]="field.label | localize"
        >
            <ng-container *ngFor="let fieldOption of field.options; let i = index">
                <div
                    *ngIf="i % 2 !== 0"
                ></div>
                @if (fieldOption.key !== checkBoxToHide) {
                    <div
                        role="listitem"
                        class="agpr-checkboxesContainer"
                        [ngClass]="{ 'agpr-checkboxesContainer--twoColumns': twoColumns }"
                    >
                        <agpr-checkbox
                            [id]="id + '.checkboxes_' + i"
                            [(ngModel)]="value"
                            [value]="fieldOption.key"
                            [label]="fieldOption.label"
                            [infoCircleTooltip]="fieldOption.tooltip"
                            [disabled]="fieldOption.disabled"
                            name="checkboxesOptions"
                            [binary]="field.binary"
                            (ngModelChange)="changes.emit($event)"
                        >
                        </agpr-checkbox>
                    </div>
                }

            </ng-container>
        </div>
        <div
            *ngIf="field.description"
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>
    </div>
    @if (this.field.message && this.displayMessage) {
        <agpr-message [severity]="messageSeverities.info">
            <span>{{ 'Reports.formField.noLabelsForColumnCharts' | localize }}</span>
        </agpr-message>
    }
}
